import { render, staticRenderFns } from "./businessCardDashboard.vue?vue&type=template&id=21fa4305&scoped=true&"
import script from "./businessCardDashboard.vue?vue&type=script&lang=js&"
export * from "./businessCardDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa4305",
  null
  
)

export default component.exports